<template>
  <div class="container bg-outline-danger">
    <div class="row py-5">
      <div class="col-sm-12 my-5">
        <div class="card-text text-center mb-5">
          <h1 class="text-success" v-if="successful">
            Your account is successfully confirmed. Please
            <router-link :to="{ path: '/login' }" tag="button"
              >log in</router-link
            >
            to continue.
          </h1>
          <h1 class="text-danger" v-else>{{ message }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Confirm Email",
  data() {
    return {
      message: "",
      successful: false,
    };
  },
  mounted() {
    // security/0.4: new signed-URL flow. Registration emails now land here
    // with `?intent=<url-encoded signed URL>` and we POST to the absolute
    // URL. The API's `signed` middleware validates the HMAC + expiry; the
    // controller enforces single-use via a cache-based nonce.
    const intent = this.$route.query.intent;
    if (intent) {
      this.confirmEmail(intent);
      return;
    }

    // Legacy path — old registration emails were of the form
    // `/confirm-email/<opaque-id>`. That scheme is retired (see
    // security/0.4). Fail explicitly rather than silently POSTing a
    // legacy id that the API now rejects with 410.
    const legacyToken = this.$route.params.token;
    if (legacyToken) {
      this.message =
        "This confirmation link uses a retired scheme. Please re-request the confirmation email to receive a new link.";
    }
  },
  methods: {
    confirmEmail(signedUrl) {
      this.successful = false;
      let loader = this.$loading.show({
        canCancel: true,
        color: "#0367a9",
      });
      // Absolute URL — axios bypasses its baseURL when the URL includes a
      // scheme. Signature is part of the query string, so nothing extra to
      // send in the body.
      this.$axios.post(signedUrl, {}).then(
        (response) => {
          loader.hide();
          if (response.data.success) {
            this.successful = true;
          } else {
            this.message =
              (response.data && response.data.message) ||
              "Could not confirm your email.";
          }
        },
        (error) => {
          loader.hide();
          this.successful = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
  },
};
</script>
